export default (name?: string) => {
  if(!name) {
    return ''
  }
  return ['k-border', name].join('-')
}
